var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "playerList" } } },
                        [_vm._v(_vm._s(_vm.$t("entities.player.plural")))]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.id))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("entities.player.singular")))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.lastName")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.lastName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.dni")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.dni))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.birthdate")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getDateFormat(_vm.model.birthdate))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.dorsal")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.dorsal))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.position")
                              }
                            },
                            [
                              _c("app-entity-link", {
                                attrs: {
                                  entityName: "position",
                                  property: _vm.model.position
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.picture")
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: _vm.model.picture.url,
                                  width: "10%",
                                  height: "10%"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Created at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.created
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Updated at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.modified
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group mt-3" },
                            [
                              _vm.hasRoleToUpdate
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-pencil-square-o",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.edit()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.edit")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-history",
                                        type: "infor"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.history()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToDelete
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-trash",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.destroy()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "page-title" }, [
                        _vm._v(_vm._s(_vm.$t("entities.team.singular")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.team.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.category")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.category.label))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36a124af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a124af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/player/player-show.vue
// module id = null
// module chunks = 